module.exports = __webpack_public_path__ + "img/krinnenspitze.15eca166.jpg";